// docs.js

(function () {
  const STORAGE_KEYS = {
    DROPDOWNS: 'docsDropdownOpenIds',
  };

  let dropdownState = new Set();
  let menuIsOpen = false;
  let initialized = false;

  /* ------------------------------------------- */
  /*  HELPERS BÁSICOS                           */
  /* ------------------------------------------- */

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function isHome() {
    const pageType = document.body && document.body.dataset.pageType;
    if (pageType) return pageType === 'index';

    const path = window.location.pathname.replace(/\/+$/, '');
    return path === '' || path === '/';
  }

  function normalizePath(href) {
    try {
      const u = new URL(href, window.location.origin);
      return u.pathname.replace(/\/+$/, '');
    } catch (e) {
      return (href || '').replace(/\/+$/, '');
    }
  }

  /* ------------------------------------------- */
  /*  SESSION STORAGE: DROPDOWNS                */
  /* ------------------------------------------- */

  function safeLoadDropdownState() {
    try {
      const raw = window.sessionStorage.getItem(STORAGE_KEYS.DROPDOWNS);
      if (!raw) return new Set();
      const arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return new Set();
      return new Set(arr);
    } catch (e) {
      return new Set();
    }
  }

  function safeSaveDropdownState() {
    try {
      const arr = Array.from(dropdownState);
      window.sessionStorage.setItem(STORAGE_KEYS.DROPDOWNS, JSON.stringify(arr));
    } catch (e) { }
  }

  /* ------------------------------------------- */
  /*  MENÚ LATERAL (SIN PERSISTENCIA)           */
  /* ------------------------------------------- */

  function defaultMenuOpenForCurrentContext() {
    if (isDesktop()) {
      return !isHome();
    } else {
      return false;
    }
  }

  function applyMenuState(open) {
    const layout = document.querySelector('.docs-layout');
    const sidebar = document.querySelector('.docs-sidebar');
    const overlay = document.getElementById('docs-overlay');

    if (!layout || !sidebar) return;

    menuIsOpen = !!open;

    document.body.classList.toggle('nav-open', menuIsOpen);
    document.body.classList.toggle('nav-closed', !menuIsOpen);

    if (menuIsOpen) {
      layout.classList.add('docs-layout--nav-open');
      layout.classList.remove('docs-layout--nav-closed');
      sidebar.classList.add('docs-sidebar--open');
      sidebar.classList.remove('docs-sidebar--closed');
    } else {
      layout.classList.remove('docs-layout--nav-open');
      layout.classList.add('docs-layout--nav-closed');
      sidebar.classList.remove('docs-sidebar--open');
      sidebar.classList.add('docs-sidebar--closed');
    }

    // Overlay solo en mobile
    if (overlay) {
      if (!isDesktop() && menuIsOpen) {
        overlay.classList.add('docs-overlay--visible');
      } else {
        overlay.classList.remove('docs-overlay--visible');
      }
    }

    // MICRO-OPTIMIZACIÓN
    sidebar.style.willChange = "transform";
    layout.style.willChange = "grid-template-columns";
  }

  function toggleMenu(forceState) {
    const next = typeof forceState === 'boolean' ? forceState : !menuIsOpen;
    applyMenuState(next);
  }

  /* ------------------------------------------- */
  /*  ACTIVO + APERTURA AUTOMÁTICA ANCESTROS     */
  /* ------------------------------------------- */

  function markActiveLinksAndEnsureParentsOpen(navRoot) {
    if (!navRoot) return;

    const currentPath = normalizePath(window.location.pathname);
    const links = navRoot.querySelectorAll('.nav-item__link');

    navRoot.querySelectorAll('.nav-item__header').forEach(header => {
      header.classList.remove('is-active');
    });

    const activeLinks = [];

    links.forEach((link) => {
      const href = link.getAttribute('href') || '';
      const linkPath = normalizePath(href);

      if (linkPath === currentPath) {
        const header = link.closest('.nav-item')?.querySelector('.nav-item__header');
        if (header) header.classList.add('is-active');
        activeLinks.push(link);
      }
    });

    activeLinks.forEach((link) => {
      let li = link.closest('.nav-item');

      while (li) {
        const header = li.querySelector('.nav-item__header');
        if (header) {
          const toggle = header.querySelector('.nav-item__toggle');
          if (toggle) {
            const id = toggle.getAttribute('data-toggle-id');
            if (id) dropdownState.add(id);
          }
        }

        const parentUl = li.parentElement;
        if (!parentUl) break;
        li = parentUl.closest('.nav-item');
      }
    });

    safeSaveDropdownState();
  }

  /* ------------------------------------------- */
  /*  APLICAR ESTADO A DROPDOWNS                 */
  /* ------------------------------------------- */

  function applyDropdownState(navRoot) {
    if (!navRoot) return;

    const toggles = navRoot.querySelectorAll('.nav-item__toggle');

    toggles.forEach((toggle) => {
      const id = toggle.getAttribute('data-toggle-id');
      const controlsId = toggle.getAttribute('aria-controls');
      const dropdown = controlsId ? document.getElementById(controlsId) : null;

      if (!id || !dropdown) return;

      const shouldBeOpen = dropdownState.has(id);

      toggle.setAttribute('aria-expanded', shouldBeOpen ? 'true' : 'false');

      if (shouldBeOpen) {
        dropdown.hidden = false;
        dropdown.classList.add('nav-level--open');
      } else {
        dropdown.hidden = true;
        dropdown.classList.remove('nav-level--open');
      }
    });
  }

  /* ------------------------------------------- */
  /*  EVENTOS DROPDOWN                           */
  /* ------------------------------------------- */

  function bindDropdownEvents(navRoot) {
    if (!navRoot) return;

    const toggles = navRoot.querySelectorAll('.nav-item__toggle');

    toggles.forEach((toggle) => {
      if (toggle.dataset.docsBound === 'true') return;
      toggle.dataset.docsBound = 'true';

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const id = toggle.getAttribute('data-toggle-id');
        const controlsId = toggle.getAttribute('aria-controls');
        const dropdown = controlsId ? document.getElementById(controlsId) : null;

        if (!id || !dropdown) return;

        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const nextState = !isExpanded;

        toggle.setAttribute('aria-expanded', nextState ? 'true' : 'false');

        if (nextState) {
          dropdown.hidden = false;
          dropdown.classList.add('nav-level--open');
          dropdownState.add(id);
        } else {
          dropdown.hidden = true;
          dropdown.classList.remove('nav-level--open');
          dropdownState.delete(id);
        }

        safeSaveDropdownState();
      });
    });
  }

  /* ------------------------------------------- */
  /*  LINKS ACTIVOS: NO RECARGAR MISMA URL       */
  /* ------------------------------------------- */

  function bindActiveLinkNoRedirect(navRoot) {
    if (!navRoot) return;

    const currentPath = normalizePath(window.location.pathname);
    const links = navRoot.querySelectorAll('.nav-item__link');

    links.forEach((link) => {
      if (link.dataset.docsBound === 'true') return;
      link.dataset.docsBound = 'true';

      link.addEventListener('click', function (event) {
        const href = link.getAttribute('href') || '';
        const linkPath = normalizePath(href);

        if (linkPath === currentPath) {
          event.preventDefault();
        }
      });
    });
  }

  /* ------------------------------------------- */
  /*  BOTONES DEL MENÚ + OVERLAY                 */
  /* ------------------------------------------- */

  function bindMenuButtons() {
    const openBtn = document.getElementById('open-nav');
    const closeBtn = document.getElementById('close-nav');
    const overlay = document.getElementById('docs-overlay');

    if (openBtn) {
      if (isDesktop() && !isHome()) {
        openBtn.style.display = 'none';
      } else {
        openBtn.style.display = '';
      }
    }

    if (openBtn && !openBtn.dataset.docsBound) {
      openBtn.dataset.docsBound = 'true';
      openBtn.addEventListener('click', (event) => {
        event.preventDefault();
        toggleMenu();
      });
    }

    if (closeBtn && !closeBtn.dataset.docsBound) {
      closeBtn.dataset.docsBound = 'true';
      closeBtn.addEventListener('click', (event) => {
        event.preventDefault();
        toggleMenu(false);
      });
    }

    if (overlay && !overlay.dataset.docsBound) {
      overlay.dataset.docsBound = 'true';
      overlay.addEventListener('click', (event) => {
        event.preventDefault();
        toggleMenu(false);
      });
    }

    if (!document.documentElement.dataset.docsEscBound) {
      document.documentElement.dataset.docsEscBound = 'true';
      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' && menuIsOpen) {
          toggleMenu(false);
        }
      });
    }
  }

  /* ------------------------------------------- */
  /*  RESIZE                                     */
  /* ------------------------------------------- */

  function handleResize() {
    const desired = defaultMenuOpenForCurrentContext();
    applyMenuState(desired);
  }

  function bindResizeListener() {
    if (window.__docsResizeBound) return;
    window.__docsResizeBound = true;

    window.addEventListener('resize', handleResize);
  }

  /* ------------------------------------------- */
  /*  INIT (Turbo + DOMContentLoaded)            */
  /* ------------------------------------------- */

  function init() {
    if (initialized) return; // <- evita lags y re-binds

    const navRoot = document.getElementById('docs_navigation');
    if (!navRoot) return;

    dropdownState = safeLoadDropdownState();
    markActiveLinksAndEnsureParentsOpen(navRoot);
    applyDropdownState(navRoot);

    requestAnimationFrame(() => {
      document.querySelectorAll('.nav-item__toggle').forEach(t => {
        t.classList.add('nav-toggle-animated');
      });
    });

    bindDropdownEvents(navRoot);
    bindActiveLinkNoRedirect(navRoot);

    const initialMenuState = defaultMenuOpenForCurrentContext();
    applyMenuState(initialMenuState);
    bindMenuButtons();
    bindResizeListener();

    initialized = true;
  }

  /* ----- IMPORTANTE: RESETEAR INIT EN CAMBIO DE DOM TURBO ----- */
  document.addEventListener("turbo:before-render", () => {
    initialized = false;
  });

  document.addEventListener('turbo:load', init);
  document.addEventListener('turbo:render', init);
  document.addEventListener('DOMContentLoaded', init);
})();
